import Api from "./api";

class UserApi {
    api = new Api();

    /**
     * Получение данных текущего пользователя
     */
    getCurrent() {
        return this.api.get('users/current');
    }
    /**
     * Отправка выполнения события пользователя
     */
    sendEvent(eventType) {
        return this.api.post('users/setEvent', {
            eventType: eventType
        })
    };
    /**
     * Отправка выполнения события пользователя
     */
    removeEvent(eventType) {
        return this.api.post('users/removeEvent', {
            eventType: eventType
        })
    };
    /**
     * Получение списка проектов пользователя
     */
    getProjectList() {
        return this.api.get('projects');
    }
    /**
     * Отправка верификации email
     */
    sendVerifyMail() {
        return this.api.get('users/send/verify/email');
    }
    /**
     * Подгрузка списка email корпоративных коллег (для владельца)
     * @return {Promise<[{email: value}]>}
     */
    getCorporateColleagues() {
        return this.api.get('/panel/corporate/colleague');
    }
    /**
     * Подгрузка списка email добавленных пользователей
     * @return {Promise<[{email: value}]>}
     */
    getCorporateUsers() {
        return this.api.get('/panel/corporate/users');
    }
    /**
     * Удаление пользователя из списка добавленных
     */
    removeCorporateUser(data = {email: null}) {
        return this.api.delete('/panel/corporate/users', data);
    }
    /**
     * Добавление пользователя в список
     */
    addCorporateUser(data = {email: null}) {
        return this.api.post('/panel/corporate/users', data);
    }
    /**
     * Приглашение пользователя в список
     */
    inviteCorporateUser(data = {email: null}) {
        return this.api.post('/panel/corporate/users/invite', data);
    }
    /**
     * Сохранение настроек доступа к отчетам
     */
    saveUserShareSettings(data) {
        return this.api.post('/panel/corporate/share-settings', data);
    }
    /**
     * Получение ссылки для подключения телеграм
     */
    getLinkTelegramConnect() {
        return this.api.get('/users/get-link-telegram-connect')
    }
    /**
     * Пуллинг проверки подключения Телеграм
     * @return {Promise<{isConnected: boolean}>}
     */
    isTelegramConnected() {
        return this.api.get('/users/is-telegram-connected');
    }
    /**
     * Сохранение FCM-токена для web push
     * @param data {{
     *     token: string,
     *     userAgent: string,
     *     isMobile: boolean,
     * }}
     */
    saveFcmToken(data) {
        return this.api.post('/users/fcm-token', data);
    }
    /**
     * Отправляем статистику переходов по партнерской программе
     */
    sendPartnerMoveStat(data = {partnerId: null, uri: null, ref: null}) {
        return this.api.post('/partners/add-stat-move', data);
    }

    /**
     * Регистрация
     * @param data{{
     *     email: string,
     *     password: string,
     *     phone: string,
     *     captchaToken?: string,
     * }}
     * @returns {Promise<*>}
     */
    registration(data) {
        return this.api.post('/users/registration', data);
    }

    /**
     * Логин
     * @param data{{
     *     email: string,
     *     password: string,
     *     captchaToken?: string,
     * }}
     * @returns {Promise<*>}
     */
    login(data) {
        return this.api.post('/users/login', data);
    }

    forgotPassword(data = {email: null}) {
        return this.api.post('/users/forgotpassword', data);
    }

    restorePassword(data = {password: null, code: null}) {
        return this.api.post('/users/restorepassword', data);
    }

    yandexLoginProcess(data = {token: null}) {
        return this.api.post('/users/yandex/login', data);
    }

    setQualification(data = {tool: null, otherTool: null, job: null, otherJob: null}) {
        return this.api.post('/users/set-qualification', data);
    }

    getHistoryEarnings(data = {page: null}) {
        return this.api.get('/partners/get-history-earnings', data);
    }

    upTariff(tariffId) {
        return this.api.post('users/up-tariff', {
            tariffId: tariffId
        })
    };

    /**
     * Добавляем, обновляем пользовательские настройки, в зависимости, что отправили
     * @param data{{
     *     // включение/отключение левого меню
     *     isLeftMenu?: Boolean,
     *     // избранные пункты меню
     *     menuFavoriteItems?: int[],
     * }}
     */
    setSettings(data) {
        return this.api.patch('users/settings', data);
    }

    /**
     * Заявка на удаление аккаунта
     * @param data {{
     *     reasonId: Number,
     *     reasonOther?: String,
     * }}
     * @returns {Promise<{
     *     result: true,
     * }>}
     */
    deleteAccount(data) {
        return this.api.delete('panel/user/delete', data);
    }

    /**
     * Отмена заявки на удаление
     * @returns {Promise<{
     *     result: true,
     * }>}
     */
    restoreAccount() {
        return this.api.post('panel/user/restore');
    }

    /**
     * Переключение push-уведомлений в браузере
     * @param data {{
     *     push: boolean,
     * }}
     * @returns {Promise<{
     *     result: true,
     * }>}
     */
    togglePushNotifications(data) {
        return this.api.post('panel/user/push-notifications', data);
    }
}

export default new UserApi();
